import { Tooltip, Typography } from '@mui/material';
import React from 'react';
import { truncateString } from "../../commonFunctions/CommonFunctions";

// Define an interface for your component props
interface StatusProps {
    value: string;
    toolTip?: boolean;
    style?: React.CSSProperties;
}

// Function to determine the color based on the status value
const getStatusInfo = (value: string | boolean): { color: string; text: string } => {
    // Handle boolean values
    if (typeof value === 'boolean') {
        return value 
            ? { color: 'green', text: 'Verified' }
            : { color: '#A9A9A9', text: 'Not Verified' };
    }

    // Handle string values (existing logic)
    switch (value?.toLowerCase()) {
        case 'approved':
        case 'active':
        case 'verified':
        case 'true':
            return { color: 'green', text: 'Verified' };

        case 'rejected':
            return { color: '#D2122E', text: 'Rejected' };
        case 'absent':
            return { color: '#AA0000', text: 'Absent' };
        case 'in active':
        case 'inactive':
        case 'not verified':
        case 'false':
            return { color: '#A9A9A9', text: 'Not Verified' };
        case 'pending':
            return { color: 'orange', text: 'Pending' };
        default:
            return { color: 'black', text: value || 'Unknown' };
    }
};

export const WSStatus: React.FC<StatusProps> = React.memo(({ value, toolTip = false, style }) => {
    const { color, text } = getStatusInfo(value);

    return (
        <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
            {/* Dot prefix with the status color */}
            <span
                style={{
                    backgroundColor: color,
                    borderRadius: '50%',
                    width: 8,
                    height: 8,
                    marginRight: 6,
                    display: 'inline-block',
                }}
            />
            {toolTip ? (
                <Tooltip title={text} placement="top">
                    <Typography style={{ color: color, fontSize: '0.875rem', ...style }}>
                        {truncateString(text, 20)}
                    </Typography>
                </Tooltip>
            ) : (
                <Typography style={{ color: color, fontSize: '0.875rem', ...style }}>
                    {text}
                </Typography>
            )}
        </div>
    );
});
